import React, { Component } from 'react';
import TableHome from './TableHome';
import Analysis from './Analysis';
import { TopLeft, TopRightAnalysis } from './HeaderUI';
import { Radio, Popover, Spin } from 'antd';
import { fetchResults, formatResultsData, getMyLocation } from './ApiUtils';
import ListState from './ListState';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = { stateList: [], stateShorts: [], resultsMap: {}, partyLogos: {}, stateIndex: 1,
        radioValue: 1, width: window.innerWidth, height: window.innerHeight, popupOpen: false,
        stateResults: {}, updatedTime: '', votesMap: {}, currentState: '', isLoading: true,
        leadPartyMap: {}, constiToolTip: {}, myState: '', stateMPMap: {}, stateMLAMap: {},
        isMpMla: { mp: true, mla: true } };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.getUserIP();
        this.setTableData();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      
      updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
      }

    setTableData = () => {
        fetchResults(response => {
            console.log('response=',response);
            if(response&&response.status==='success') {
                let { stateList, stateShorts, partyLogos, resultsMap, updatedTime, votesMap,
                    leadPartyMap, constiToolTip } = formatResultsData(response.stateResults);
                console.log('resultsMap=',resultsMap);
                let stateValue = JSON.parse(localStorage.getItem('stateValue'));
                if((stateValue||stateValue==0)&&stateList[stateValue]) {
                    console.log('localStorage stateValue=',stateValue);
                } else {
                    let currentState = this.state.myState;
                    stateValue = 1;
                    if(currentState) {
                        let index = stateList.findIndex(o => o.name === currentState);
                        if(index>=0) { stateValue = index; }
                    }
                }
                let { name } = stateList[stateValue];
                let currentState = name;
                let shortStateName = stateShorts[stateValue];
                console.log('shortStateName=',shortStateName);
                let isMpMlaObj = { mp: true, mla: true };
                if(response.stateResults[shortStateName]) {
                    isMpMlaObj = response.stateResults[shortStateName];
                } else {
                    isMpMlaObj = { mp: true, mla: false };
                }
                this.setState({ stateList, stateShorts, resultsMap, updatedTime, partyLogos, votesMap,
                    stateResults: response.stateResults, currentState, stateIndex: stateValue,
                    leadPartyMap, constiToolTip, isLoading: false, isMpMla: isMpMlaObj });
                this.fetchMapPoints(shortStateName);
            }
        });
    }

    getUserIP = () => {
        getMyLocation(response => {
            console.log('response=',response);
            if(response&&response.region) {
                this.setState({ myState: response.region });
            }
        })
    }

    fetchMapPoints = (shortStateName) => {
        console.log('shortStateName=',shortStateName);
        if(shortStateName=='IN') {
            import('./coordinates/India.json').then(mapCoordinates => {
                this.setState({ stateMPMap: mapCoordinates, stateMLAMap: {}, isLoading: false });
            })
            return;
        }
        import('./coordinates/'+shortStateName+'-MP.json').then(mapCoordinates => {
            this.setState({ stateMPMap: mapCoordinates });
        })
        import('./coordinates/'+shortStateName+'-MLA.json').then(mapCoordinates => {
            this.setState({ stateMLAMap: mapCoordinates, isLoading: false });
        })
    }

    onRefresh = () => {
        console.log('on Refresh clicked.');
        this.setState({ isLoading: true });
        this.setTableData();
    }

    onStateChange = (e) => {
        let value = e.target.value;
        console.log('radio checked', value);
        this.setState({ isLoading: true });
        let { stateList, stateShorts, stateResults } = this.state;
        let { name } = stateList[value];
        let currentState = name;
        let isMpMlaObj = { mp: true, mla: true };
        let shortStateName = stateShorts[value];
        this.fetchMapPoints(shortStateName);
        console.log('this.state.stateResults=',stateResults);
        if(stateResults[shortStateName]) {
            isMpMlaObj = stateResults[shortStateName];
        } else {
            isMpMlaObj = { mp: true, mla: false };
        }
        console.log('shortStateName=',shortStateName,' isMpMlaObj=',isMpMlaObj);
        this.setState({ stateIndex: value, currentState, popupOpen: false, isMpMla: isMpMlaObj });
        localStorage.setItem('stateValue', JSON.stringify(value));
    };

    onChangeRadio  = (e) => {
        let value = e.target.value;
        console.log('radio val=', value);
        if(value) {
            this.setState({ radioValue: value });
        }
    };

    handleOpenChange = (newOpen) => {
        this.setState({ popupOpen: newOpen });
    }

    render() {

        const { stateIndex, currentState, stateShorts, partyLogos, resultsMap, stateResults, isLoading,
            isMpMla, stateList, radioValue, width, height, updatedTime, votesMap, leadPartyMap,
            constiToolTip, stateMLAMap, stateMPMap, popupOpen } = this.state;
        console.log('width=',width,' height=', height,' radioValue=',radioValue,' stateIndex=',stateIndex);
        console.log('stateList=',stateList);
        let stateCode = stateShorts[stateIndex];
        let votes = votesMap[stateCode];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', backgroundColor: '#fff' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <TopLeft />
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Radio.Group
                            onChange={this.onChangeRadio}
                            value={radioValue}
                            optionType="button"
                            buttonStyle="solid"
                            style={{ display: 'flex' }}
                        >
                            <Popover placement="bottomRight" trigger="click" open={popupOpen}
                            content={<ListState stateIndex={stateIndex} stateList={stateList}
                            height={height} onStateChange={this.onStateChange} />}
                            onOpenChange={this.handleOpenChange}>
                                <Radio key={0} value={0} style={{ width: 220, fontSize: 20, lineHeight: '18px',
                                display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0 }}>
                                    {currentState}
                                </Radio>
                            </Popover>
                            <Radio key={1} value={1} style={{ width: 120, fontSize: 16 }}>Analysis</Radio>
                            <Radio key={2} value={2} style={{ width: 120, fontSize: 16 }}>Table</Radio>
                        </Radio.Group>
                    </div>
                    <TopRightAnalysis isIndia={stateIndex==0} updatedTime={updatedTime} votes={votes}
                    isMpMla={isMpMla} onRefresh={this.onRefresh} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100vw' }}>
                    <div style={{ display: 'flex', flex: 1 }}>
                        {(radioValue==2)
                        ?
                        <TableHome width={width} height={height} stateIndex={stateIndex} isMpMla={isMpMla}
                        currentState={stateCode} resultsMap={resultsMap} stateResults={stateResults} />
                        :
                        <Analysis width={width} height={height} stateIndex={stateIndex} currentState={stateCode}
                        partyLogos={partyLogos} resultsMap={resultsMap} stateResults={stateResults}
                        isMpMla={isMpMla} leadPartyMap={leadPartyMap} constiToolTip={constiToolTip}
                        stateMLAMap={stateMLAMap} stateMPMap={stateMPMap} />
                        }
                    </div>
                </div>
                <div style={{ display: isLoading ? 'flex' : 'none', position: 'absolute', width: '100%',
                height: '100%', zIndex: 99, backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
                    <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center',
                    alignItems: 'center' }}>
                        <Spin size="large" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;